import React, { FC } from 'react';
import { TModalComponentsListProps } from '../../types/productSeriesDetailFeature.types';
import InnerCard from './innerCard';
import './styles.scss';

const InnerCards: FC<TModalComponentsListProps> = (props) => {
  const innerComponents = props.components;
  const cardsCount = innerComponents?.length || 0;

  return (
    <div className="inner-cards-modules" style={{ backgroundColor: props.backgroundColor || '#FFF' }}>
      {innerComponents?.map((component) => (
        <InnerCard component={component} cardsCount={cardsCount} key={component?.id} />
      ))}
    </div>
  );
};

export default InnerCards;
